/* FeaturedCard.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _40 = "._4cvr1h6o{align-items:center}";
const _39 = "._1bah1h6o{justify-content:center}";
const _38 = "._1e0c1txw{display:flex}";
const _37 = "._18u01wug{margin-left:auto}";
const _36 = "._otyridpf{margin-bottom:0}";
const _35 = "._2hwx1wug{margin-right:auto}";
const _34 = "._19pkidpf{margin-top:0}";
const _33 = "._1bsb11ux{width:140px}";
const _32 = "._4t3i11ux{height:140px}";
const _31 = "._qrwq7vkz{border-top-right-radius:1pc}";
const _30 = "._13li7vkz{border-top-left-radius:1pc}";
const _29 = "._1yt4hiv4{padding:var(--ds-space-400)}";
const _28 = "@media (min-width:64rem){._1yaghiv4{padding:var(--ds-space-400)}}";
const _27 = "._1yt4l6l0{padding:var(--ds-space-300)}";
const _26 = "@media (min-width:48rem) and (max-width:63.99rem){._1os2idpf{flex-grow:0}._8os5idpf{flex-shrink:0}._16xt1inv{flex-basis:calc(50% - 64px)}}";
const _25 = "._1w0vnqa1:focus-visible{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _24 = "._10xfglyw:focus-visible{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _23 = "._vjfr18uv:focus-visible{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _22 = "._1ejj17er:focus-visible{box-shadow:var(--ds-shadow-overlay)}";
const _21 = "._1ygb4suz:focus-visible{outline:2px solid var(--ds-border-focused)}";
const _20 = "._1iohnqa1:active{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _19 = "._c2waglyw:active{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _18 = "._1nrm18uv:active{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _17 = "._1di617i0:active{background-color:var(--ds-surface-raised-hovered)}";
const _16 = "._jf4cnqa1:hover{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _15 = "._1bnxglyw:hover{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _14 = "._9oik18uv:hover{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _13 = "._1dbz17er:hover{box-shadow:var(--ds-shadow-overlay)}";
const _12 = "._ajmmnqa1{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _11 = "._1hmsglyw{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _10 = "._4bfu18uv{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _9 = "._v56416gf{transition:box-shadow .2s ease-in-out}";
const _8 = "._i0dl1yub{flex-basis:calc(75% - 16px)}";
const _7 = "._1o9zidpf{flex-shrink:0}";
const _6 = "._16jlidpf{flex-grow:0}";
const _5 = "._19it7v06{border:1px solid var(--ds-border)}";
const _4 = "._bfhk143w{background-color:var(--ds-surface-raised)}";
const _3 = "._2rko7vkz{border-radius:1pc}";
import { media } from '@atlaskit/primitives/responsive';
import { BodySmall, H4 } from '@atlassian/mpac-primitives';
import React from 'react';
import { Link } from 'react-router-dom';
import { useHomepageAnalytics } from '../../hooks/useHomepageAnalytics';
const _2 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _ = "._19pk1eps{margin-top:var(--ds-space-100)}";
const Description = forwardRef((_ref, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pk1eps _syaz1k3w", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Description.displayName = 'Description';
}
const Card = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = Link,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_2rko7vkz _bfhk143w _19it7v06 _16jlidpf _1o9zidpf _i0dl1yub _v56416gf _4bfu18uv _1hmsglyw _ajmmnqa1 _1dbz17er _9oik18uv _1bnxglyw _jf4cnqa1 _1di617i0 _1nrm18uv _c2waglyw _1iohnqa1 _1ygb4suz _1ejj17er _vjfr18uv _10xfglyw _1w0vnqa1 _1os2idpf _8os5idpf _16xt1inv", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Card.displayName = 'Card';
}
const ContentWrapper = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_27, _28]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1yt4l6l0 _1yaghiv4", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ContentWrapper.displayName = 'ContentWrapper';
}
const ImageContainer = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_29, _30, _31]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1yt4hiv4 _13li7vkz _qrwq7vkz", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ImageContainer.displayName = 'ImageContainer';
}
const ImageWrapper = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_32, _33, _34, _35, _36, _37, _38, _39, _40]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_4t3i11ux _1bsb11ux _19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _1bah1h6o _4cvr1h6o", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ImageWrapper.displayName = 'ImageWrapper';
}
export const FeaturedCard = _ref6 => {
  let {
    title,
    description,
    image,
    backgroundColor,
    navigationUrl,
    ariaHidden
  } = _ref6;
  const {
    trackFeaturedCollectionClick
  } = useHomepageAnalytics();
  return /*#__PURE__*/React.createElement(Card, {
    to: navigationUrl,
    onClick: () => trackFeaturedCollectionClick(title)
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    style: {
      backgroundColor
    }
  }, /*#__PURE__*/React.createElement(ImageWrapper, null, /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: ariaHidden ? '' : title
  }))), /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(H4, {
    as: "h3"
  }, title), /*#__PURE__*/React.createElement(Description, null, description)));
};